import React, {
  createContext,
  useContext,
  useCallback,
  ReactNode,
} from 'react';

interface AccountContextType {
  onAccountLinked: () => void;
}

const AccountContext = createContext<AccountContextType | undefined>(undefined);

export const useAccount = () => {
  const context = useContext(AccountContext);
  if (!context) {
    throw new Error('useAccount must be used within an AccountProvider');
  }
  return context;
};

interface AccountProviderProps {
  children: ReactNode;
}

export const AccountProvider: React.FC<AccountProviderProps> = ({
  children,
}: AccountProviderProps) => {
  const onAccountLinked = useCallback(() => {}, []);

  const value: AccountContextType = {
    onAccountLinked,
  };

  return (
    <AccountContext.Provider value={value}>{children}</AccountContext.Provider>
  );
};
